module.exports = __webpack_public_path__ + "img/weChat.aea1d4df.svg";